// Application constants
export const FREE_REQUESTS_PER_MONTH = 100;

// API pricing constants (matching server pricing)
export const API_PRICING = {
  '/api/face-detect': 0.001, // $0.001 per request
  '/api/face-detect-batch': 0.002, // $0.002 per request
  '/api/ai-image-detect': 0.002, // $0.002 per request
  '/api/composite-check': 0.003, // Dynamic pricing (max when both options selected)
  '/api/trust-score': 0.03, // Fixed $0.03 per request regardless of configuration
  '/api/text-analysis': 0.002, // $0.02 per request
  '/api/face-verify': 0.01, // $0.01 per request
  '/api/moderation/submit-profile': 0.03, // $0.03 per request (same as trust-score)
  '/api/health': 0, // Free
} as const;

// Composite check dynamic pricing based on selected options
export const COMPOSITE_CHECK_PRICING = {
  both: 0.003, // Both face_detect and ai_image_detect selected
  faceOnly: 0.001, // Face detect only
  aiOnly: 0.002, // AI detect only
  none: 0, // No options selected (should return error)
} as const;
